import { useAuthStore } from '@/stores/auth.store'
import { ROLE_REDIRECT } from '@/permissions/roles'
import { canAccessAdminOrDev } from '@/permissions/access'

export function authMiddleware(to, from, next) {
  const auth = useAuthStore()

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return next({ name: 'login' })
  }

  if (to.name === 'login' && auth.isAuthenticated) {
    return next(ROLE_REDIRECT[auth.role])
  }

  if (to.meta.roles && !to.meta.roles.includes(auth.role)) {
    return next(ROLE_REDIRECT[auth.role] ?? { name: 'login' })
  }

  if (to.meta.adminOrDev && !canAccessAdminOrDev(auth.role, auth.user?.is_dev === true)) {
    return next(ROLE_REDIRECT[auth.role] ?? { name: 'login' })
  }

  if (to.meta.devOnly && !auth.user?.is_dev) {
    return next(ROLE_REDIRECT[auth.role] ?? { name: 'dashboard' })
  }

  next()
}
